import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  decodeToken,
  getRedirectPath,
  saveAuthToken,
} from "../../utils/authHeader";

function Success() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get("token");

    if (token) {
      saveAuthToken(token);

      const decoded = decodeToken(token);

      if (decoded) {
        const path = getRedirectPath({
          role: decoded.role,
          isOnboardingCompleted: decoded.isOnboardingCompleted,
        });

        navigate(path, { replace: true });
      } else {
        navigate("/sign-in");
      }
    } else {
      navigate("/sign-in");
    }
  }, [navigate, searchParams]);

  return <div className="text-center mt-5">Signing you in...</div>;
}

export default Success;
